module.exports = __webpack_public_path__ + "static/get-on-google-play-683690317c8f1eea8c1f999cc18da097.svg";